import rise from "/app/images/features/icons/virtual-labs.webp";
import forms from "/app/images/features/icons/forms.webp";
import moodle from "/app/images/features/icons/lms.webp";
import quiz from "/app/images/features/icons/assessment.webp";
import digitalforum from "/app/images/features/icons/digital-forum.webp";
import aggregation from "/app/images/features/icons/content-aggregation.webp";

const ServiceInfo = [
  {
    imgsrc: forms,
    serviceTitle: "ISEA Forms",
    serviceContent:
      "Forms creation will be made easy. Easily create different types of forms, like online sessions, workshops registration, giving feedback, or answering surveys, is now super easy!",
    // url: "name"
  },
  {
    imgsrc: rise,
    serviceTitle: " Virtual Labs",
    serviceContent:
      " The Virtual Labs web application is intended to provide Labs virtually to users. By using this application the user can reserve slot and go through lab",
  },
  {
    imgsrc: moodle,
    serviceTitle: "Learning Management System",
    serviceContent:
      " LMS application intended to manage, create, and deliver online training programs.",
  },
  {
    imgsrc: quiz,
    serviceTitle: "Assessment",
    serviceContent:
      " Check your knowledge on various cyber security concepts by attempting our assessements and get certificed passing the criteria. Also helps you understand your knowledge on concepts and improve learning process.",
  },
  {
    imgsrc: digitalforum,
    serviceTitle: "Digital Forum",
    serviceContent: " Coming Soon...",
  },
  {
    imgsrc: aggregation,
    serviceTitle: "Content Aggregation Platform",
    serviceContent: " CComing Soon...",
  },
];

export default ServiceInfo;
